// extracted by mini-css-extract-plugin
export default {"container":"dz_g","imageContainer":"dz_fz","textContainer":"dz_dF","title":"dz_cX","description":"dz_c"};